import { FormLayout, TextField, Button } from "@shopify/polaris";
import React, { useCallback, useState, useEffect, useRef } from "react";
const TranslationRow = (props) => {
  const object = JSON.parse(props.object);
  const handleChangeHandle = (newValue) => {
    const newState = props.data.map((obj) => {
      if (obj.handle === object.handle) {
        return { ...obj, handle: newValue.replaceAll(" ", "_") };
      }
      return obj;
    });
    props.updateData(newState);
    // setData(newState);
  };
  const handleChangeText = (newValue) => {
    const newState = props.data.map((obj) => {
      if (
        obj.text === object.text &&
        obj.language === props.language &&
        obj.handle === object.handle
      ) {
        return { ...obj, text: newValue };
      }
      return obj;
    });
    props.updateData(newState);
  };
  const handleDelete = () => {};
  return (
    <tr>
      <td>
        <TextField onChange={handleChangeHandle} value={object.handle} />
      </td>
      <td>
        <TextField onChange={handleChangeText} value={object.text} />
      </td>
    </tr>
  );
  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
  function findArrayElementById(array, id) {
    return array.find((element, index) => {
      return element.id === id;
    });
  }
};

export default TranslationRow;
